export default __webpack_public_path__ + "static/media/NotoSerifDevanagari.9d1a9c35.ttf";